import React from 'react';

const CaretDownIcon = ({size, color, className, ...props}) => (
    <svg
        width={size || "20"}
        height={size || "20"}
        fill={color}
        viewBox="0 0 122.88 116.65"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        className={className}
        {...props}
    >
        <g>
            <polygon points="122.88,0 122.88,30.82 61.44,80.593 0,30.82 0,0 61.44,49.772 122.88,0"/>
        </g>
    </svg>
);

export default CaretDownIcon;